import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { userService } from '../../_services/user.service';

function ReportPopup({ text, closePopup }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [monthList, setMonthList] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState('');
    
    const [paramsName] = useState(() => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            if (!user) {
                userService.logout();
                return '';
            }
            return user.paramsname || '';
        } catch {
            userService.logout();
            return '';
        }
    });

    const fetchCommissionData = useCallback(async () => {
        setLoading(true);
        setError('');
        
        try {
            const response = await fetch('/api/ws/wh_commission_type', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'X-Browser-Url': window.location.href 
                },
                body: JSON.stringify({
                    whname: 'admin',
                    mname: ''
                })
            });
            
            const data = await response.json();
            
            if (data?.length > 0 && data[0].monthList) {
                setMonthList(data[0].monthList);
                if (data[0].monthList.length > 0) {
                    setSelectedMonth(data[0].monthList[0].monthYearname);
                }
            } else {
                //setError('Data not found');
            }
        } catch (err) {

            //setError('Failed to load data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCommissionData();
    }, [fetchCommissionData]);

    const handleDownload = useCallback((e) => {
        e.preventDefault();
        
        if (!selectedMonth) return;
        
        try {
            const originLocation = window.location.protocol + '//' + window.location.host;
            const url = `${originLocation}/report/admincommreport_New?&name=${paramsName}&csvfor=admin&m=${selectedMonth}&processor=0`;
            window.open(url, '_blank');
        } catch (err) {

        }
    }, [selectedMonth, paramsName]);

    const handleOpenChange = useCallback((open) => {
        if (!open) {
            closePopup();
        }
    }, [closePopup]);

    return (
        <Dialog open={true} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{text}</DialogTitle>
                </DialogHeader>
                
                <div className="flex flex-col gap-4">
                    {loading ? (
                        <div className="flex items-center justify-center p-8 min-h-[120px]">
                            <Loader2 className="h-8 w-8 animate-spin text-primary" />
                        </div>
                    ) : monthList.length > 0 ? (
                        <form onSubmit={handleDownload} className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <Label htmlFor="month-select">Select Month, Year</Label>
                                <Select value={selectedMonth} onValueChange={setSelectedMonth}>
                                    <SelectTrigger id="month-select">
                                        <SelectValue placeholder="Select month" />
                                    </SelectTrigger>
                                    <SelectContent className="max-h-[200px] overflow-y-auto">
                                        {monthList.map((item, index) => (
                                            <SelectItem key={index} value={item.monthYearname}>
                                                {item.monthYearname.replace(',', ', ')}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                        </form>
                    ) : (
                        <div className="flex items-center justify-center p-8 text-muted-foreground text-center text-[15px]">
                            {error || 'No data available'}
                        </div>
                    )}
                </div>

                {monthList.length > 0 && (
                    <DialogFooter>
                        <Button type="submit" disabled={!selectedMonth} onClick={handleDownload}>
                            Download
                        </Button>
                        <Button type="button" variant="secondary" onClick={closePopup}>
                            Cancel
                        </Button>
                    </DialogFooter>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default ReportPopup;
